<template> 
  <div class="app">
    <AppHeader fixed>
      <b-navbar-nav class="space">
        <DefaultHeaderDropdownAccnt />
      </b-navbar-nav>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="/dashboard">
        <img class="navbar-brand-full" src="img/logo-inpar.png" height="25" alt="Inpar" />
        <img class="navbar-brand-minimized" src="img/logo-inpar.png" height="30" alt="Inpar" />
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" />
    </AppHeader>

    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader/>
        <SidebarForm/>

        <SidebarNav :navItems="filteredNav"></SidebarNav>

        <SidebarFooter/>
        <SidebarMinimizer/>
      </AppSidebar>

      <main class="main">
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>

      <AppAside fixed>
        <DefaultAside/>
      </AppAside>
    </div>

    <TheFooter>
      <div>
        <span class="ml-1">&copy; {{ new Date().getFullYear() }} Publicis.</span>
      </div>
    </TheFooter>
  </div>
</template>

<script>
import nav from '@/_nav'
import { 
  Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, 
  SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, 
  AsideToggler, Footer as TheFooter, Breadcrumb 
} from '@coreui/vue'
import DefaultAside from './DefaultAside'
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'

export default {
  name: 'DefaultContainer',
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer
  },
  data () {
    return {
      nav: nav.items
    }
  },
  computed: {

    filteredNav() {
      const user = this.$auth.user();
      let userRoles = [];

      if (user && user.roles) {
        userRoles = Array.isArray(user.roles)
          ? user.roles.map(r => typeof r === 'object' ? r.name : r)
          : typeof user.roles === 'string'
            ? [user.roles]
            : [];
      }

      const filterItems = (items) => {
        return items
          .filter(item => {
            if (item.permission) {
              return item.permission.some(role => userRoles.includes(role));
            }
            return true;
          })
          .map(item => ({
            ...item,
            children: item.children ? filterItems(item.children) : null
          }));
      };

      return filterItems(this.nav);
    },

    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched.filter((route) => route.name || route.meta.label )
    }
  }
}
</script>